// src/AdminApp.jsx
// Served only on admin.kailux.co.za (see main.jsx, which picks this over
// App.jsx based on hostname). Deliberately tiny: no client-facing routes
// (/dashboard, /clients, /trial-balance, etc.) exist here at all, so there's
// nothing for a firm user to stumble into and nothing to link to it from the
// client app. Admin access lives ONLY on this subdomain now.
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import ErrorBoundary from './components/ErrorBoundary'

import Login from './pages/Login'
import AdminBoard from './pages/AdminBoard'
import AdminAcceptInvite from './pages/AdminAcceptInvite'

export default function AdminApp() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
        `}</style>
        <ErrorBoundary>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/accept-invite" element={<AdminAcceptInvite />} />
            <Route path="/admin" element={<ProtectedRoute><AdminBoard /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/admin" replace />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    </AuthProvider>
  )
}
